module.exports = __webpack_public_path__ + "static/1-9467ccb688999ee683882cab79fdea4e.jpg";